import { LeadsService } from "./../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "./../services/projects/projects.service";
import { CookieService } from "ngx-cookie-service";
import { Component } from "@angular/core";
import swal from "sweetalert2";

@Component({
  selector: "block-requests-list",
  templateUrl: "./block-requests-list.component.html",
  styleUrls: ["./block-requests-list.component.css"],
})
export class BlockRequestsListComponent {
  userInfo: any;
  blockList: any;
  last_page_url: any;

  constructor(
    public cookieService: CookieService,
    public projectsService: ProjectsService,
    public slimLoadingBarService: SlimLoadingBarService,
    public errorHandlingService: ErrorHandlerService,
    private leadsService: LeadsService
  ) {
    this.userInfo = JSON.parse(window.localStorage.getItem("userProfile"));
  }

  ngOnInit() {
    this.getBlockList();
  }

  approveUnit(requestId) {
    this.slimLoadingBarService.start();
    this.projectsService.acceptBlockUnit(requestId).subscribe(
      (data) => {
        this.getBlockList();
        swal("Woohoo!", "Accepted block Unit succesfully!", "success");
      },
      (err) => {
        this.errorHandlingService.handleErorr(err);
      },
      () => {
        this.slimLoadingBarService.complete();
      }
    );
  }

  declinelUnit(requestId) {
    this.slimLoadingBarService.start();
    this.projectsService.declineBlockUnit(requestId).subscribe(
      (data) => {
        this.getBlockList();
        swal("Woohoo!", "Declined block Unit succesfully!", "success");
      },
      (err) => {
        this.errorHandlingService.handleErorr(err);
      },
      () => {
        this.slimLoadingBarService.complete();
      }
    );
  }

  getBlockList(is_export = false) {
    this.slimLoadingBarService.start();
    this.projectsService.getBlockList({ is_export }).subscribe(
      (data: any) => {
        if (is_export) {
          window.open(data.url);
        } else {
          this.blockList = data;
        }
      },
      (err) => {
        this.errorHandlingService.handleErorr(err);
      },
      () => {
        this.slimLoadingBarService.complete();
      }
    );
  }

  getNewRecord(event) {
    this.blockList = event;
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/block-requests-list/block-requests-list.component.ts